import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { postPurchaseSurveySearchSchema } from "@/domains/surveys/models/schemas";

const PostPurchase = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_guest/post-purchase/")({
  component: PostPurchase,
  validateSearch: postPurchaseSurveySearchSchema,
  onError: (error) => {
    if (error.routerCode === "VALIDATE_SEARCH") {
      throw redirect({ to: "/" });
    }
  },
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/post-purchase/survey", search });
  },
});
